import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { first, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ProductService } from "../services/api";

// Validator to check if a client tag already exists
export function clientTagValidator(productService: ProductService): AsyncValidatorFn
{
    return (control: AbstractControl) =>
    {
        // Delay the validation by 700 milliseconds
        return timer(700).pipe(switchMap(() =>
        {
            return productService.getUsedClientTags().pipe()
                .pipe(
                    // Check if the control value exists in the list of client tags
                    map((clientTags) =>
                        (clientTags.find(clientTag => clientTag == control.value) !== undefined) ? { clientTagAlreadyExists: true } : null
                    )
                ).pipe(
                    // Complete the observable after the first emission
                    first()
                );
        }));
    };
}
